import type { ReactNode } from "react";

import Tooltip from "common/core/tooltip";
import { Substyle } from "common/core/typography";
import Icon from "common/core/icon";

export function InfoTooltip({ children }: { children: ReactNode }) {
  return (
    <Tooltip
      target={
        <Substyle textColor="subtle">
          <Icon name="info-circle" />
        </Substyle>
      }
      placement="top"
    >
      {children}
    </Tooltip>
  );
}
